export default "__VITE_ASSET__E1P9J36P__"